const STORAGE_KEY = "@sayagie/home-availability-dismissed";
const MAX_ENTRIES = 30;

let memory = null;

const load = () => {
  if (memory) return memory;

  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || "[]");
    memory = Array.isArray(parsed) ? parsed : [];
  } catch {
    memory = [];
  }

  return memory;
};

export const isAvailabilityDismissed = (signature) =>
  Boolean(signature) && load().includes(signature);

export const dismissAvailability = (signature) => {
  if (!signature || isAvailabilityDismissed(signature)) return;

  memory = [...load(), signature].slice(-MAX_ENTRIES);

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(memory));
  } catch {}
};
